const SESSION_KEY = 'opac_analytics_session_id';
const VISIT_TRACK_KEY = 'opac_analytics_visit_tracked_date';

const buildSessionId = () => {
  const randomPart = Math.random().toString(36).slice(2, 10);
  const timePart = Date.now().toString(36);
  return `sess_${timePart}_${randomPart}`;
};

export const getAnalyticsSessionId = () => {
  try {
    let sessionId = localStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId = buildSessionId();
      localStorage.setItem(SESSION_KEY, sessionId);
    }
    return sessionId;
  } catch (_error) {
    return buildSessionId();
  }
};

const getTodayKey = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const shouldTrackVisitToday = () => {
  try {
    return localStorage.getItem(VISIT_TRACK_KEY) !== getTodayKey();
  } catch (_error) {
    return true;
  }
};

export const markVisitTrackedToday = () => {
  try {
    localStorage.setItem(VISIT_TRACK_KEY, getTodayKey());
  } catch (_error) {
    // Ignore storage failures for analytics.
  }
};

export const trackVisit = async (page = window.location.pathname) => {
  const sessionId = getAnalyticsSessionId();
  const response = await fetch('/api/analytics/visit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sessionId, page }),
  });

  if (!response.ok) {
    throw new Error('Failed to track visit');
  }

  return response.json();
};

export const fetchVisitorSummary = async () => {
  const response = await fetch('/api/visitors');
  if (!response.ok) {
    throw new Error('Failed to fetch visitor summary');
  }
  return response.json();
};

export const trackEvent = async (eventName, metadata = {}, page = window.location.pathname) => {
  try {
    const sessionId = getAnalyticsSessionId();
    await fetch('/api/analytics/event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId,
        eventName,
        page,
        metadata,
      }),
    });
  } catch (_error) {
    // Never block user actions for analytics failures.
  }
};
